// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/BloqueiosAgenda_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /bloqueios_agenda/delete/{id}
 *
 * Returns bool success result after deletion.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface BloqueiosAgenda_DeleteResponseDados {
dados: boolean
}

export type BloqueiosAgenda_DeleteResponse = ApiResponse<BloqueiosAgenda_DeleteResponseDados>;

registerResponseContract('BloqueiosAgenda_DeleteResponse', {
  dados: { type: 'boolean', required: true },
})
